import React__default from 'react';
import clsx from 'clsx';
import { Icon } from '../Icon/Icon.component.js';
import styles from './Dropdown.module.scss.js';

var DropdownIndicator = function (props) {
    var selectProps = props.selectProps, trigger = props.trigger;
    var menuIsOpen = selectProps.menuIsOpen, isReadOnly = selectProps.isReadOnly;
    return (React__default.createElement(Icon, { name: "ChevronDownIcon", alt: "dropdown", size: trigger || isReadOnly ? 0 : 24, className: clsx(styles.Dropdown_icon, menuIsOpen && styles.Dropdown_icon___open) }));
};
DropdownIndicator.displayName = 'DropdownIndicator';

export { DropdownIndicator as default };
